import { useCallback, useRef, useState } from 'react';

interface SecurityCodeHelp {
  readonly helpOpen: boolean;
  readonly setHelpOpen: (open: boolean) => void;
  readonly openHelpOnFirstFocus: () => void;
}

function useSecurityCodeHelp(): SecurityCodeHelp {
  const [helpOpen, setHelpOpen] = useState(false);
  const inputFocusedBefore = useRef(false);

  const openHelpOnFirstFocus = useCallback((): void => {
    if (inputFocusedBefore.current) return;
    inputFocusedBefore.current = true;
    setHelpOpen(true);
  }, []);

  return { helpOpen, setHelpOpen, openHelpOnFirstFocus };
}

export { useSecurityCodeHelp };
